export const getJsonString = (item: unknown, formatted?: boolean): string => {
  let appLocalDataObject = '';
  const space = '\t';
  try {
    appLocalDataObject = formatted
      ? JSON.stringify(item, null, space)
      : JSON.stringify(item);
  } catch (e) {
    console.error(e);
  }
  return appLocalDataObject;
};

export const getJsonObject = (
  item: string
): Record<string, string | null> | null => {
  try {
    return JSON.parse(item);
  } catch (e) {
    return null;
  }
};
